module.exports = {
    title:'Eagle-edu - Friends',
    courseColleagues:'Course colleagues',
    follow:'Follow',
    unfollow:'Unfollow',
    following:'Following',
    followers:'Followers',
    friends:'Friends'
}